export default __webpack_public_path__ + "static/media/get_access_key.829789b1.gif";